import Toast from '../../../client/toast.js'

export default class My
{
	static set_coupon(code)
	{
		App._common.cookie('coupon', code)
		Toast.success(`クーポンが購入時に使用されるようになりました`)
	}

	static logout()
	{
		if(!confirm('ログアウトしますか？')) return

		$.get('/logout/', (success) =>
		{
			if(success)
			{
				Toast.success('ログアウトしました')
				setTimeout(() => location.href = '/', 2000)
			}
			else
			{
				Toast.warning('エラーが発生しました。時間を置いて再度お試しください。')
			}
		})
	}

	static init_survey(type)
	{
		this[`_${type}`] = JSON.parse(App._common.cookie(type) ?? '{}')
	}

	static _cancel = {}

	static cancel_survey(name, value, input, disabled)
	{
		this._cancel[name] = value
		App._common.cookie('cancel', JSON.stringify(this._cancel))

		if(input) $(input).prop('disabled', disabled)
	}

	static _quit = {}

	static quit_survey(name, value, input, disabled)
	{
		this._quit[name] = value
		App._common.cookie('quit', JSON.stringify(this._quit))

		if(input) $(input).prop('disabled', disabled)
	}

	static quit_confirm(form)
	{
		let checked = true

		$(form).find('input[type="checkbox"]').each((index, element) =>
		{
			if(element.checked) return

			checked = false
			Toast.warning('全ての項目をご確認の上、チェックを入れてください')

			return false
		})

		if(!checked) return false

		return App.common.Network.form_post(form, (success) => setTimeout(() =>
			{
				if(success) location.href = '/'
			}, 2000),
		)
	}

	static load_address(form, postal, prefecture, address)
	{
		$.get('/_postal/', {code: form[postal].value}, (data) =>
		{
			if(data.error) Toast.warning(data.error)
			else
			{
				form[prefecture].value = data.prefecture
				form[address].value = data.address
			}
		})
	}

	static delete_address(identifier)
	{
		if(confirm('削除しますか？')) App.common.Ui.post('/my/', {__action: 'deliver_delete', address: identifier})
	}

	static set_bookmark(product, heart, name)
	{
		const on = $(heart).hasClass(name) ? 0 : 1

		App.common.Ui.post('/my/', {
			__action: 'bookmark',
			product : product,
			on      : on,
		})

		if(on) $(heart).addClass(name)
		else $(heart).removeClass(name)
	}

	static set_token(token)
	{
		const data = new FormData()

		data.set('__action', 'card')
		data.set('token', token)

		App.common.Network.post('/my/', data)
	}

	static _status

	static _state = 0

	static card_init(status, state)
	{
		this._status = status
		this._state = state
	}

	static card_submit(form)
	{
		if(!confirm('変更しますか？')) return

		if(this._status < ++this._state)
		{
			Toast.warning(`クレジットカードの変更回数の限度数に達しました。24時間後に再度お試しください。`)
			return
		}

		try
		{
			SpsvApi.spsvCreateToken(
				form.number.value,
				form.expiry_year.value,
				form.expiry_month.value,
				form.code.value,
			)
		}
		catch(exception)
		{
			const data = new FormData()
			data.set('__action', 'card')

			$.ajax({
				url : '/my/',
				type: 'POST',

				processData: false,
				contentType: false,
				data       : data,
			})

			Toast.warning(`カード情報の登録に失敗しました。時間を置き、再度お試しください。 (${exception.message})`)
		}
	}

	static change_type(product)
	{
		$(`[data-remodal-id="alternative_${product}"]`).remodal().open()
	}

	static change_count(product)
	{
		$(`[data-remodal-id="count_${product}"]`).remodal().open()
	}
}
